import React from 'react';
import PropTypes from 'prop-types';

import { animation } from '../../styles/constants';

const HomeCircles = ({ progress, width, height, top, left }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    href="http://www.w3.org/1999/xlink"
    xlinkHref="http://www.w3.org/1999/xlink"
    viewBox="0 0 2917 2917"
    style={{
      position: 'fixed',
      willChange: 'transform, opacity',
      transitionProperty: 'transform',
      transitionDuration: `${animation.homeCircle}ms`,
      transitionTimingFunction: 'ease-in-out',
      transform: `rotate(${-(progress * 90) + 30}deg)`,
      opacity: top && left && width && height && progress >= 0 ? 1 : 0,
      width: `${width}px`,
      height: `${height}px`,
      top,
      left
    }}
  >
    <ellipse cx="1458.5" cy="791.5" rx="124.5" ry="426.3" fill="#00B7FF" />
    <ellipse cx="2125.5" cy="1458.5" rx="426.3" ry="124.5" fill="#FF8806" />
    <ellipse cx="791.5" cy="1458.5" rx="426.3" ry="124.5" fill="#0097FF" />
    <ellipse cx="1458.5" cy="2125.5" rx="124.5" ry="426.3" fill="#D200FF" />
    <path
      d="M1217.8,1458.5c96.6-61.9,178.8-144.1,240.7-240.7c-78.8-123-124.5-269.3-124.5-426.3
      c0-157,45.7-303.3,124.5-426.3C1317.8,145.6,1071.7,0,791.5,0C354.4,0,0,354.4,0,791.5c0,280.2,145.6,526.3,365.2,667
      c123-78.8,269.3-124.5,426.3-124.5S1094.8,1379.7,1217.8,1458.5z"
      fill="#06C2FC"
    />
    <path
      d="M2551.8,1458.5c-123,78.8-269.3,124.5-426.3,124.5c-157,0-303.3-45.7-426.3-124.5
      c-96.6,61.9-178.8,144.1-240.7,240.7c78.8,123,124.5,269.3,124.5,426.3s-45.7,303.3-124.5,426.3c140.7,219.6,386.8,365.2,667,365.2
      c437.1,0,791.5-354.4,791.5-791.5C2917,1845.3,2771.4,1599.2,2551.8,1458.5z"
      fill="#FF4AD4"
    />
    <path
      d="M1458.5,1217.8c61.9,96.6,144.1,178.8,240.7,240.7c123-78.8,269.3-124.5,426.3-124.5
      c157,0,303.3,45.7,426.3,124.5c219.6-140.7,365.2-386.8,365.2-667C2917,354.4,2562.6,0,2125.5,0c-280.2,0-526.3,145.6-667,365.2
      c78.8,123,124.5,269.3,124.5,426.3C1583,948.5,1537.3,1094.8,1458.5,1217.8z"
      fill="#FFA000"
    />
    <path
      d="M1458.5,1699.2c-61.9-96.6-144.1-178.8-240.7-240.7c-123,78.8-269.3,124.5-426.3,124.5s-303.3-45.7-426.3-124.5
      C145.6,1599.2,0,1845.3,0,2125.5C0,2562.6,354.4,2917,791.5,2917c280.2,0,526.3-145.6,667-365.2c-78.8-123-124.5-269.3-124.5-426.3
      S1379.7,1822.2,1458.5,1699.2z"
      fill="#0054A4"
    />
  </svg>
);

HomeCircles.propTypes = {
  progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default HomeCircles;
